import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';
import {
	CheckBoxWrapper,
	CheckBox,
	CheckBoxLabel
} from '../../base/forms/checkBox';
import {
	StyledErrorMessage
} from '../../base/forms/formik';

const StyledWrapper = styled.div`
	position: relative;
	padding-left: 3.5rem;

	${CheckBoxLabel} {
		margin: 0;
	}
`;

const StyledCheckWrapper = styled.div`
	position: absolute;
	left: 0;
`;

const FormField = ({
	field = {},
	required = false
}) => {
	return (
		<StyledWrapper>
			<Field
				name={field.fieldName}>
				{(fieldProps) => {
					const { value, name } = fieldProps.field;
					const { setFieldValue } = fieldProps.form;

					const onClick = () => {
						setFieldValue(name, !value);
					};

					return (
						<CheckBoxWrapper
							onClick={onClick}
							checked={value}>
							<div>
								<StyledCheckWrapper>
									<CheckBox
										id="credit-info-terms"
										{...fieldProps.field} />
								</StyledCheckWrapper>
								<CheckBoxLabel htmlFor="credit-info-terms">
									{field.labelName}
									{required && <span>*</span>}
								</CheckBoxLabel>
							</div>
						</CheckBoxWrapper>
					);
				}}
			</Field>
			<StyledErrorMessage name={field.fieldName} component="div" />
		</StyledWrapper>
	);
};

export default FormField;
